import { inject, Service } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {GoogleService} from "./google-service";
import {Observable} from "rxjs";
import {Entity} from "../entity/entity";
import {EntityHistory} from "../model/entity-history";

@Service()
export class EntityHistoryService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private readonly baseUrl: string = environment.serviceUrl;

  getEntityHistory(entity: Entity): Observable<EntityHistory> {
    const url: string = this.baseUrl + 'entityHistory/' + entity.id.entityId + '/' + entity.id.entityRevision;
    return this.http.get<EntityHistory>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
